import * as React from 'react';

export default class CollapsibleContentFull extends React.PureComponent<{}, {}> {
    render() {
        return <div className="collapsible-content-full">{this.props.children}</div>;
    }
}
